import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { RestService } from '../rest.service';
import { UserService } from '../user.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private user: UserService,
    private rest: RestService
  ) {}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean { 
      localStorage.setItem('lastURL', state.url)


      if ( this.user.isLoggedIn ){ return true; }
      
      this.user.promiseGetAuth()
      .then( (data) => { return true; })
      .catch( (er) => console.log('catch -> ' + JSON.stringify(er)) );

      this.router.navigate(['/login']);
      return false;
  }

  canDeactivate(){
    if (!this.user.isLoggedIn) {
      //console.log('no logueado');
      return false;
    } else {
      //console.log('logueado...');
      return true;
    }
  }
}